import React from 'react';
import PropTypes from 'prop-types';
import Card from 'kepler/lib/components/Card';
import '@paypalcorp/pp-vx/dist/components/radio/radio.css';

class SingleSelectionCard extends React.Component {
  onChange = value => {
    let { handleChange } = this.props;
    handleChange(value);
  };

  render() {
    let { step, isActive } = this.props;
    return (
      <Card
        className={`step-container ${isActive ? 'step-active' : ''} ppvx_radio`}
      >
        <input
          className="ppvx_radio__input"
          type="radio"
          name={step.value}
          id={step.value}
          onClick={() => {
            this.onChange(step.value);
          }}
          onKeyDown={e => e.keyCode === 13 && this.onChange(step.value)}
          checked={isActive}
        />
        <label
          className={`step-container-content ppvx_radio__label ${step.value}`}
          htmlFor={step.value}
        >
          <img
            className="step-container-content-image"
            src={step.icon}
            alt=""
            role="presentation"
          />
          <p className="step-container-content-title">{step.title}</p>
        </label>
      </Card>
    );
  }
}

SingleSelectionCard.propTypes = {
  handleChange: PropTypes.func,
  step: PropTypes.object,
  isActive: PropTypes.bool
};

export default SingleSelectionCard;
